import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/linebaccounts.scss";

export default function LineBAccountsList() {
  const [accounts, setAccounts] = useState([]);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchAccounts = async (searchTerm = "", pageNumber = 1) => {
    setLoading(true);
    const endpoint = searchTerm
      ? `/api/linebaccounts/search/${encodeURIComponent(searchTerm)}/${pageNumber}`
      : `/api/linebaccounts/${pageNumber}`;

    try {
      const response = await fetch(endpoint);
      const result = await response.json();

      setAccounts(result.data || []);
      setTotalPages(result.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch accounts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts(query, page);
  }, [query, page]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setPage(1); // Reset to first page on new search
  };

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div className="lineb-list">
    <h2>Line B Accounts</h2>
    <p className="guide">You can search by number or name. Click any account to view and update. Mark as 'Visited' to add remarks, then submit. Return to the list to continue.</p>
    <input
      className="search-input"
      type="text"
      value={query}
      onChange={handleSearchChange}
      placeholder="Search by account or customer name"
    />

    {loading ? (
      <p>Loading...</p>
    ) : (
      <>
        <table className="accounts-table">
          <thead>
            <tr>
              <th>Account</th>
              <th>Connection</th>
              <th>Mtr Serial</th>
              <th>Account Status</th>
              <th>Customer Name</th>
              <th>Customer Category</th>
              <th>Walkroute</th>
              <th>Visited</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {accounts.length > 0 ? (
              accounts.map((item, index) => (
                <tr
                  key={index}
                  className="account-row"
                  onClick={() => navigate(`/linebaccounts/${item.account}`)}
                >
                  <td>{item.account}</td>
                  <td>{item.connection}</td>
                  <td>{item.mtr_serial}</td>
                  <td>{item.account_status}</td>
                  <td>{item.customer_name}</td>
                  <td>{item.customer_category}</td>
                  <td>{item.walkroute}</td>
                  <td>{item.visited ? "Yes" : "No"}</td>
                  <td>{item.remarks || ""}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" align="center">No accounts found</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination">
          <button onClick={() => goToPage(page - 1)} disabled={page <= 1}>
            Previous
          </button>
          <span>Page {page} of {totalPages}</span>
          <button onClick={() => goToPage(page + 1)} disabled={page >= totalPages}>
            Next
          </button>
        </div>
      </>
    )}
  </div>

  );
}
